import React from 'react';
import {
  ChartArea,
  ChartContainer,
  ChartDivider,
  ChartHeader,
  Container,
  Team,
  TeamWrapper,
  Title,
  Versus
} from './styled';
import SportsTeamLogo from '../../../../teamLogo';
import { toJS } from 'mobx';
import { _COMPARISON_CHART_INIT } from '../../../../../routes/score/basketball/store/constants';
import SingleBarChart from './SingleBarChart';

const TeamSeasonStat = ({ data }) => {
  const { teamStat, rank } = data;

  const homeRank = rank.homeRanking;
  const awayRank = rank.awayRanking;
  if (!homeRank || !awayRank) {
    return null;
  } else {
    return (
      <Container>
        <Title>팀 시즌 성적</Title>
        <TeamWrapper>
          <Team>
            <SportsTeamLogo
              imgSize={'70'}
              imgUrl={teamStat.home.imgPath}
              isLazy={true}
            />
            <h3>{homeRank.teamName}</h3>
            <p>
              {homeRank.ranking}위 {homeRank.winCount}승 {homeRank.lossCount}패
            </p>
          </Team>
          <Versus>
            <span>VS</span>
          </Versus>
          <Team>
            <SportsTeamLogo
              imgSize={'70'}
              imgUrl={teamStat.away.imgPath}
              isLazy={true}
            />
            <h3>{awayRank.teamName}</h3>
            <p>
              {awayRank.ranking}위 {awayRank.winCount}승 {awayRank.lossCount}패
            </p>
          </Team>
        </TeamWrapper>
        <ChartContainer>
          {Object.keys(_COMPARISON_CHART_INIT).map((key, idx) => {
            return (
              <li key={_COMPARISON_CHART_INIT[key].key}>
                <ChartArea>
                  <SingleBarChart
                    value={data.comparisonChart[key].home.p}
                    active={
                      data.comparisonChart[key].visible &&
                      data.comparisonChart[key].home.active
                    }
                    location="left"
                    text={data.comparisonChart[key].home.v}
                  />
                  <ChartHeader>
                    <span>{_COMPARISON_CHART_INIT[key].name}</span>
                  </ChartHeader>
                  <ChartDivider />
                  <SingleBarChart
                    value={data.comparisonChart[key].away.p}
                    active={
                      data.comparisonChart[key].visible &&
                      data.comparisonChart[key].away.active
                    }
                    location="right"
                    text={data.comparisonChart[key].away.v}
                  />
                </ChartArea>
              </li>
            );
          })}
        </ChartContainer>
      </Container>
    );
  }
};

export default TeamSeasonStat;
